module.exports = new __parcel__URL__("ai.853086d4.gif").toString();